import { callApi } from '@/api/apibase'

export const getCourses = function () {
  return callApi('GET', `/api/external/greencourse/getcourses`)
}
